import * as React from 'react';
import { withIntl } from '@grandvisionhq/state';
import { ClearFacetFilter } from '../../ClearFacetFilter/ClearFacetFilter.js';
import { FacetSearchBox } from '../../FacetSearchBox/FacetSearchBox.js';

const FacetHeaderMobile = ({ refineCount , onSearch , onClear , intl  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile__heading"
    }, onClear && /*#__PURE__*/ React.createElement(ClearFacetFilter, {
        onClear: onClear,
        isDisabled: refineCount === 0,
        label: intl.getLabel('search.filters.clear', {
            defaultValue: 'clear'
        })
    })), /*#__PURE__*/ React.createElement("span", {
        className: "facet-header-mobile__divider"
    }), onSearch && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile__search"
    }, /*#__PURE__*/ React.createElement(FacetSearchBox, {
        placeholder: intl.getLabel('search.filters.placeholder'),
        onSearch: (event)=>onSearch(event.target.value)
    }))));
};
var FacetHeaderMobile$1 = withIntl(FacetHeaderMobile);

export { FacetHeaderMobile, FacetHeaderMobile$1 as default };
//# sourceMappingURL=FacetHeaderMobile.js.map
